import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import hopscotch from 'hopscotch';
import Tour from 'config/Tour';

import { Icon } from 'components';

class Navbar extends Component {
  handleStartTour = () => {
    hopscotch.startTour(Tour);
  };

  render() {
    return (
      <div className="navbar-custom">
        <div className="container-fluid">
          <div id="navigation">
            <div className="row">
              <div className="col-10">
                <ul className="navigation-menu">
                  <li>
                    <Link to="/admin/dashboard">
                      <Icon name="layer-group" />
                      <span>Dashboard</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/admin/participants">
                      <Icon name="users" />
                      <span>Participantes</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/admin/interviews">
                      <Icon name="list" />
                      <span>Entrevistas</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/admin/journeys">
                      <Icon name="map-signs" />
                      <span>Jornadas</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/admin/report">
                      <Icon name="clipboard-list" />
                      <span>Relatório</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/layouts/Default/components/Navbar/index.js